<template>
  <div :class="['file-item', 'frequent-item', !disableClickStyle && 'clickable']" @click="handleItemClick">
    <div class="thumb-icon">
      <thumb-icon
        :name="item.name"
        :thumbnail="item.item.thumbnail"
        :typeIcon="item.freq_type === 'file' && item.item.type_icon"
        :space="item.item_type"
      />
    </div>
    <div :class="['item-main', !hideAction && 'has-border-bottom']">
      <div class="item-name two-line-ellipsis">{{item.item.name}}</div>
      <div :class="['item-meta', 'ellipsis', item.item && item.item.detect_status === 'detect_invalid' && judgeIsExternal ? 'sensitive-tip': '']">
        <i v-if="item.item && item.item.is_encrypted" class="iconfont icon-file-encrypt"></i>
        <i v-if="item.item && item.item.detect_status === 'detect_invalid' && judgeIsExternal" class="iconfont icon-fail"></i>
        {{parentName}}
      </div>
    </div>
    <div v-if="!disableClickStyle && item.isForbidden" class="mask"></div>
    <div v-if="!hideAction" class="item-action has-border-bottom">
      <i class="iconfont icon-more" @click.stop="onMenuClick"/>
    </div>
  </div>
</template>
<script>
import config from '@/config'
import {i18n} from '@/utils/i18n'
import { getParentItem, checkIsExternal } from '@/utils/fileUtils'

export default {
  name: 'FrequentItem',
  i18n,
  components: {
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    hideAction: Boolean,
    disableClickStyle: Boolean,
    config: Object
  },
  data () {
    return {}
  },
  computed: {
    judgeIsExternal () {
      const { item } = this.item
      return item.detect_status === 'detect_invalid' && this.config && this.config.isSensitiveInfoDetectEnabled && !checkIsExternal(item)
    },
    parentName () {
      let text
      const { isForbidden, freq_type, item_type, item_count, item } = this.item
      if (this.judgeIsExternal) {
        text = '该文件中检测到敏感词'
      } else {
        if (isForbidden) {
          text = i18n.t('file.removed')
        } else if (freq_type === 'file') {
          const parentItem = getParentItem(item)
          text = i18n.t('file.frequent.whereIn', [parentItem.name])
        } else if (item_type === 'own') {
          if (config.enterprise_info.is_personal_space_closed) {
            text = i18n.t('file.own.closed')
          } else {
            text = i18n.tc('file.space.fileFolderAmmount', item_count ? 0 : 1, [item_count])
          }
        } else {
          text = i18n.tc('file.space.folderAmmount', item_count ? 0 : 1, [item_count])
        }
      }

      return text
    }
  },
  methods: {
    handleItemClick () {
      if (!this.item.isForbidden) {
        this.$emit('item-click', this.item.freq_type === 'file' ? this.item.item : this.item)
      }
    },
    onMenuClick () {
      this.$emit('menu-click', this.item, 'frequent')
    }
  }
}
</script>

<style>
.sensitive-tip{
  color: #ff0000;
  & .icon-fail {
    color: #ff0000;
    font-size: 12px;
    margin-right:4px;
  }
}
</style>
